import Tasks from "@pages/Task/Complience";
import ComplianceTaskList from "@pages/Task/Complience/list";
import ComplianceTaskDetails from "@pages/Task/Complience/list/Detail/TaskDetails";
import ComplianceTaskHistory from "@pages/Task/Complience/list/Detail/TaskHistory";
import TaskComments from "@pages/Task/Complience/list/Detail/TaskComments";
import TaskLicenseComments from "@pages/Task/License/list/Detail/TaskComments";
import TaskLicenseDetails from "@pages/Task/License/list/Detail/TaskDetails";
import TaskLicenseHistory from "@pages/Task/License/list/Detail/TaskHistory";
import TaskCalenderView from "@pages/Task/Complience/list/calender";
import TaskLicense from "@pages/Task/License/license";
import TasksLicense from "@pages/Task/License";
import TaskLicenseCalenderView from "@pages/Task/License/list/calender";
import MyTask from "@pages/Task/MyTask";
import TaskLicenseGroup from "@pages/Task/LicenseGroup/license";
import TaskLicenseRegion from "@pages/Task/LicenseRegion/license";
import ReportsLicenseGroup from "@pages/Task/LicenseGroup/report";

export const TaskRoutes = [
	{
		path: "/activities/task/compliance",
		name: "activities_pe_compliance",
		component: Tasks,
	},
	{
		path: "/activities/task/compliance/list/:id",
		name: "activities_pe_compliance",
		component: ComplianceTaskList,
	},
	{
		path: "/activities/task/compliance/list/calenderView/:id",
		name: "activities_pe_compliance",
		component: TaskCalenderView,
	},
	{
		path: "/activities/task/compliance/list/detail/:id/:taskId/:checkpoint_id/:firstDay/:lastDay/:locationId/:functionId",
		name: "activities_pe_compliance",
		component: ComplianceTaskDetails,
	},
	{
		path: "/activities/task/compliance/list/history/:id/:taskId/:checkpoint_id/:firstDay/:lastDay/:locationId/:functionId",
		name: "activities_pe_compliance",
		component: ComplianceTaskHistory,
	},
	{
		path: "/activities/task/compliance/list/comments/:id/:taskId/:checkpoint_id/:firstDay/:lastDay/:locationId/:functionId",
		name: "activities_pe_compliance",
		component: TaskComments,
	},
	{
		path: "/activities/task/license/group",
		name: "activities_licenses",
		component: TaskLicenseGroup,
	},
	{
		path: "/activities/task/license/group/report",
		name: "activities_licenses",
		component: ReportsLicenseGroup,
	},

	{
		path: "/activities/task/license/region",
		name: "activities_licenses",
		component: TaskLicenseRegion,
	},
	{
		path: "/activities/task/license",
		name: "activities_licenses",
		component: TaskLicense,
	},
	{
		path: "/activities/task/license/list/:id",
		name: "activities_licenses",
		component: TasksLicense,
	},
	{
		path: "/activities/task/license/list/calenderView/:id",
		name: "activities_licenses",
		component: TaskLicenseCalenderView,
	},
	{
		path: "/activities/task/license/list/detail/:id/:checkpoint_id/:locationId/:license_type_id",
		name: "activities_licenses",
		component: TaskLicenseDetails,
	},
	{
		path: "/activities/task/license/list/history/:id/:checkpoint_id/:locationId/:license_type_id",
		name: "activities_licenses",
		component: TaskLicenseHistory,
	},
	{
		path: "/activities/task/license/list/comments/:id/:checkpoint_id/:locationId/:license_type_id",
		name: "activities_licenses",
		component: TaskLicenseComments,
	},
	{
		path: "/task/my-task",
		name: "activities_pe_compliance",
		component: MyTask,
	},


];
